module.exports = __webpack_public_path__ + "bg-banner-left.png?61e03ed256a86d2d42047f8899ac1d7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-banner-left.png
// module id = 218
// module chunks = 0